import React from 'react'
import i18 from '../../../i18'

class AssignmentRuleCreate extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            config: props.config,
            vatCollectorCodes: props.vatCollectorCodes,
            invoice: props.invoice,
            invoiceItem: props.invoiceItem,

            position: 5,

            itemNameEnabled: false,
            itemName: props.invoiceItem.name,
            invoiceNumberEnabled: false,
            invoiceNumber: props.invoice.invoiceNumber,
            positionNumberEnabled: false,
            positionNumber: props.invoice.positionNumber,
            positionNumberCountryEnabled: false,
            positionNumberCountry: props.invoice.positionNumberCountry,

            vat: props.invoiceItem.vat,
            company_type: props.invoice.company_type,
            vat_code: '',
            collector_code_fk_id: '',
            main_bookkeeping_number: '',
        }
    }

    onElementChange = (event) => {
        if (event.target.attributes.name.nodeValue === 'itemName') {
            let itemName = event.target.value;
            let matches = itemName.match(/^#([0-9]{1})/);
            if (matches) {
                this.setState({
                    itemName: itemName.substring(2),
                    position: matches[1],
                });
                return;
            }
        }

        this.setState({[event.target.attributes.name.nodeValue]: event.target.value})
    }

    onKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.createRule('final');
        }
    }

    ruleValidation = () => {

        let hasSelectedRuleFilter =
            this.state.itemNameEnabled
            || this.state.invoiceNumberEnabled
            || this.state.positionNumberEnabled
            || this.state.positionNumberCountryEnabled

        if (!hasSelectedRuleFilter) {
            this.props.notifyError('A szabály létrehozásához ki kell választani, hogy mikre legyen érvényes!');
            return false;
        }

        if (!this.state.main_bookkeeping_number) {
            this.props.notifyError('Kérünk töltse ki a [Főkönyv szám] mezőt!');
            return false;
        }

        if (!this.state.collector_code_fk_id) {
            this.props.notifyError('Kérünk töltse ki a [Gyűjtő kód] mezőt!');
            return false;
        }

        if (this.state.collector_code_fk_id !== 3 && !this.state.vat_code) {
            this.props.notifyError('Kérünk töltse ki a [ÁFA Főkönyv szám] mezőt!');
            return false;
        }

        return true;
    }

    createRule = (type) => {
        if (!this.ruleValidation()) {
            return;
        }

        this.props.createRule({
            item_name: this.state.itemNameEnabled ? this.state.itemName : '',
            position: this.state.position,
            invoice_number: this.state.invoiceNumberEnabled ? this.state.invoiceNumber : '',
            vat: this.state.vat,
            company_type: this.state.company_type,
            type: type,
            position_number: this.state.positionNumberEnabled ? this.state.positionNumber : '',
            position_number_country: this.state.positionNumberCountryEnabled ? this.state.positionNumberCountry : '',
            main_bookkeeping_number: this.state.main_bookkeeping_number,
            collector_code_fk_id: this.state.collector_code_fk_id,
            vat_degree: this.state.collector_code_fk_id === 3 ? '' : this.state.vat_code,
        });

        this.setState({
            main_bookkeeping_number: '',
            collector_code_fk_id: '',
            vat_code: '',

            itemNameEnabled: false,
            invoiceNumberEnabled: false,
            positionNumberEnabled: false,
            positionNumberCountryEnabled: false
        });
    }

    renderInputCheckbox(property, className) {
        return <input
            id={property + '-' + Math.random(9999, 99999)}
            name={property}
            value={this.state[property]}
            type="checkbox"
            onChange={(event) => this.onElementChange(event)}
            className={className}
        />
    }

    renderInputText(property, className, props) {
        return <input
            {...props}
            name={property}
            value={this.state[property]}
            className={className}
            type='text'
            onChange={(event) => this.onElementChange(event)}
            onKeyDown={(event) => this.onKeyDown(event)}
        />
    }

    render() {
        return (
            <tr>
                <td>
                    {this.renderInputCheckbox('itemNameEnabled')}
                    {this.renderInputText('itemName', 'no-border-underline-text-input')}
                </td>
                <td>
                    {this.renderInputText('main_bookkeeping_number', 'bordered-input')}
                </td>
                <td>{parseInt(this.state.invoiceItem.vat, 0)}%</td>
                <td>
                    <select
                        name='collector_code_fk_id'
                        value={this.state.collector_code_fk_id}
                        ref={this.collector_code_fk_id}
                        className='minimal form-control'
                        onChange={(event) => this.onElementChange(event)}
                        onKeyDown={(event) => this.onKeyDown(event)}
                    >
                        <option value='' key='0'>Kérjük válasszon</option>
                        {this.state.vatCollectorCodes.map((el) => {
                            return <option value={el.id} key={el.id}>{el.code}&nbsp;({el.title})</option>
                        })}
                    </select>
                </td>
                <td>{this.state.invoice.tax_number}</td>
                <td>{this.state.invoice.company_name}</td>
                <td>{this.state.invoice.paymentMethodLabel}</td>
                {this.state.config.positionNumberVisible
                    ? <React.Fragment>
                        <td>
                            {this.renderInputCheckbox('positionNumberEnabled')}
                            {this.renderInputText('positionNumber', 'no-border-underline-text-input')}
                        </td>
                        <td>
                            {this.renderInputCheckbox('positionNumberCountryEnabled')}
                            {this.renderInputText('positionNumberCountry', 'no-border-underline-text-input')}
                        </td>
                    </React.Fragment>
                    : null}
                <td>
                    {this.renderInputCheckbox('invoiceNumberEnabled')}
                    {this.renderInputText('invoiceNumber', 'no-border-underline-text-input')}
                </td>
                <td>
                    {this.renderInputText('vat_code', 'bordered-input', {
                        disabled: this.state.collector_code_fk_id === 3
                    })}
                </td>
                <td>
                    <i
                        onClick={(event) => this.createRule('final')}
                        title={i18.CUSTOMER._createRulesAndProcess}
                        className='fa fa-dot-circle-o'
                        aria-hidden='true'/> &nbsp;&nbsp;
                    <i
                        onClick={(event) => this.createRule('temporarily')}
                        title={i18.CUSTOMER._oneTimeProcessing}
                        className='fa fa-check-circle'
                        aria-hidden='true'/>
                </td>
            </tr>
        )
    }
}

export default AssignmentRuleCreate


// WEBPACK FOOTER //
// ./src/components/customer/Steps/AssignmentRuleCreate.js